import type { RootStore } from "@state/stores/types";
import { action, computed, observable } from "mobx";

type RetryFunction = () => Promise<any>;

class RetryHandlerStore {
	@observable retryFunction: RetryFunction | null = null;
	@observable preserveRetry: boolean = false;

	rootStore: RootStore;

	constructor(rootStore: RootStore) {
		this.rootStore = rootStore;
	}

	@action.bound
	setRetry(retryFunction: RetryFunction, preserve: boolean = false) {
		this.retryFunction = retryFunction;
		this.preserveRetry = preserve;
	}

	@action.bound
	async executeRetry() {
		if (this.retryFunction) {
			try {
				await this.retryFunction();
				if (!this.preserveRetry) {
					this.clearRetry();
				}
			} catch (error) {
				console.error(error);
			}
		}
	}

	@computed
	get hasPendingRetry() {
		return this.retryFunction !== null;
	}

	@action.bound
	clearRetry() {
		this.retryFunction = null;
		this.preserveRetry = false;
	}
}

export default RetryHandlerStore;
